import { render, staticRenderFns } from "./ModuleColumnScroll.vue?vue&type=template&id=612ee6ba&functional=true"
var script = {}
import style0 from "./ModuleColumnScroll.vue?vue&type=style&index=0&id=612ee6ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports